import { BaseError } from './errors';

export class UnparseableDateError extends BaseError {
  constructor() {
    super(`The date/time could not be parsed`);
  }
}

export class UnsupportedTimeZoneError extends BaseError {
  constructor() {
    super(`The time zone is not supported`);
  }
}
